import React from "react"
import { Text, View } from "@react-pdf/renderer"
import { useTranslation } from "react-i18next"

import { styles } from "./PDFStyles"
import RequestPDF from "./PDFRequestTemplate"
import { Entity, LocalBike } from "models"

type SummaryBikePDFProps = {
	bike: LocalBike
	entity?: Entity
	operatorGender?: string
}

const SummaryBikePDF: React.FC<SummaryBikePDFProps> = ({ bike, entity, operatorGender }) => {
	const { t } = useTranslation()
	const listContent: string[] = t("pdf.main_bottom_list", { ns: "bike", returnObjects: true })

	return (
		<RequestPDF bike={bike} entity={entity} operatorGender={operatorGender}>
			<View>
				<Text style={[styles.p]}>{t("pdf.main_bottom_content", { ns: "bike" })}</Text>
			</View>

			<View>
				{listContent.map((item, index) => {
					return (
						<Text style={styles.li} key={index}>
							{" "}
							{item}{" "}
						</Text>
					)
				})}
			</View>

			<View style={[styles.bottomPage]}>
				<Text style={[styles.p]}>{t("pdf.greetings", { ns: "bike" })}</Text>
				<Text style={[styles.p]}>{t("pdf.signature", { ns: "bike" })}</Text>
			</View>
		</RequestPDF>
	)
}

export default SummaryBikePDF
